module.exports = xhr2;


//////////////////
// WEBPACK FOOTER
// external "xhr2"
// module id = 374
// module chunks = 0